module.exports = __webpack_public_path__ + "static/media/sup_icons_SUP_LOGO.9b2a02ef.svg";